var _excluded = ["heading", "link", "cards"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import LinkAtm from "../../atoms/LinkAtm";
import TextAtm from "../../atoms/TextAtm";
import ProductCardMol from "../../molecules/ProductCardMol";
import ProductCardsSliderOrg from "../../organisms/ProductCardsSliderOrg";
import ProductCardsWithHeaderOrg from "../../organisms/ProductCardsWithHeaderOrg";
function ProductCardsTemplate(_ref) {
  var heading = _ref.heading,
    link = _ref.link,
    cards = _ref.cards,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var slider = /*#__PURE__*/React.createElement(ProductCardsSliderOrg, null, cards.map(function (card) {
    return /*#__PURE__*/React.createElement(ProductCardMol, _extends({}, card, {
      key: card.title
    }));
  }));
  if (heading || link) {
    return /*#__PURE__*/React.createElement(ProductCardsWithHeaderOrg, _extends({}, restProps, {
      heading: heading ? /*#__PURE__*/React.createElement(React.Fragment, null, heading.caption ? /*#__PURE__*/React.createElement(TextAtm, {
        typography: "xsmall2_u",
        emphasis: "medium"
      }, heading.caption) : null, /*#__PURE__*/React.createElement(TextAtm, {
        typography: "great"
      }, heading.title)) : null,
      cta: link ? /*#__PURE__*/React.createElement(LinkAtm, {
        to: link.to,
        href: link.href,
        title: link.title,
        openInNewTab: link.openInNewTab,
        scrollTo: link.scrollTo,
        onClick: link.onClick,
        rel: link.rel
      }, link.text) : null,
      content: slider
    }));
  }
  return /*#__PURE__*/React.createElement("div", restProps, slider);
}
export default ProductCardsTemplate;